import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import LinkWrapper from "@/components/linkWrapper";
import MediaWrapper from "@/components/mediaWrapper";
import MarkdownWrapper from "@/components/markdownWrapper";

export const query = graphql`
  fragment CtaBrandPanelWithAppScreenshotData on StrapiComponentCtaBrandPanelWithAppScreenshot {
    topic
    title
    subtitle
    description
    buttons {
      ...StrapiSharedLink
    }
    image {
      ...StrapiMediaSubquery
    }
  }
`;

function BrandPanelWithAppScreenshot({ data }) {
  if (!data) {
    return <template />;
  }
  let highlightButton;
  let buttons;
  if (data.buttons) {
    buttons = [...data.buttons];
    highlightButton = buttons.shift();
  }
  return (
    <div className="bg-background-white">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="overflow-hidden rounded-lg bg-background-highlight-dark shadow-xl lg:grid lg:grid-cols-2 lg:gap-4">
          <div className="px-6 pb-12 pt-10 sm:px-16 sm:pt-16 lg:py-16 lg:pr-0 xl:px-20 xl:py-20">
            <div className="lg:self-center">
              {data.topic && (
                <h3 className="block text-base font-semibold uppercase tracking-wide text-text-white">
                  <MarkdownWrapper text={data.topic} />
                </h3>
              )}
              {data.title && (
                <h2 className="text-3xl font-extrabold text-text-white sm:text-4xl">
                  <span className="block">
                    <MarkdownWrapper text={data.title} />
                  </span>
                  {data.subtitle && (
                    <span className="block">
                      <MarkdownWrapper text={data.subtitle} />
                    </span>
                  )}
                </h2>
              )}
              {data.description && (
                <MarkdownWrapper
                  text={data.description}
                  markdownClassName="mt-4 text-lg leading-6 text-text-highlight-light"
                  replaceParagraph={false}
                />
              )}
              {Boolean(data.buttons?.length) && (
                <div className="mt-8 flex">
                  {(highlightButton?.overwriteTitle ||
                    highlightButton?.link?.title) && (
                    <div className="inline-flex">
                      <LinkWrapper
                        to={highlightButton.link?.url}
                        className="inline-flex items-center rounded-md border border-transparent bg-background-white px-5 py-3 text-base font-medium text-text-highlight shadow hover:bg-background-light-gray hover:text-text-highlight-dark"
                      >
                        {highlightButton.overwriteTitle ||
                          highlightButton.link.title}
                      </LinkWrapper>
                    </div>
                  )}
                  {buttons.map(
                    (button, index) =>
                      (button.overwriteTitle || button.link?.title) && (
                        <div key={index} className="ml-3 inline-flex">
                          <LinkWrapper
                            to={button.link?.url}
                            className="inline-flex items-center rounded-md border border-transparent bg-background-white px-5 py-3 text-base font-medium text-text-highlight shadow hover:bg-background-highlight-light"
                          >
                            {button.overwriteTitle || button.link.title}
                          </LinkWrapper>
                        </div>
                      )
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="-mt-6">
            {data.image && (
              <div className="h-full translate-x-6 translate-y-6 transform object-left-top sm:translate-x-16 lg:translate-y-20">
                <MediaWrapper
                  media={data.image}
                  divClassName="h-full"
                  className="rounded-md"
                  objectPosition="left"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

BrandPanelWithAppScreenshot.propTypes = {
  data: PropTypes.object,
};

export default BrandPanelWithAppScreenshot;
